export const unwrapSupabaseResult = (settledResult, label = "request") => {
  if (settledResult.status === "rejected") throw settledResult.reason;
  if (settledResult.value?.error) throw settledResult.value.error;
  if (!settledResult.value) {
    throw new Error(`Failed to load ${label}`);
  }
  return settledResult.value.data ?? [];
};

export const ensureAffectedRows = (requestedIds, rows, action = "Updated") => {
  const expected = new Set(requestedIds || []).size;
  const actual = Array.isArray(rows) ? rows.length : 0;
  if (actual !== expected) {
    throw new Error(`${action} ${actual} of ${expected} records`);
  }
  return rows;
};
